import { inject, Injectable, SecurityContext } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom, map } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class LandingService {
  private apiUrl = environment.apiUrl;
  private httpClient = inject(HttpClient);
  private sanitizer = inject(DomSanitizer);

  private headers = new HttpHeaders({
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0',
  });

  async getBannersFromApi() {
    const timestamp = new Date().getTime();
    return firstValueFrom(
      this.httpClient.get(`${this.apiUrl}/banners?paginate=disabled&t=${timestamp}`, { headers: this.headers })
      .pipe(
        map((response: any) => {
          return {
              data: response.data.map((banner: any) => ({
                title: banner.title,
                subtitle: banner.detail,
                image: banner.image?.url,
                button: banner.button ? {
                  label: banner.button_text || 'Button',
                  link: banner.button_url || '#',
                } : null,
              })),
          };
        })
    ));
  }

  async getCountersFromApi() {
    const timestamp = new Date().getTime();
    return firstValueFrom(
      this.httpClient.get(`${this.apiUrl}/counters?paginate=disabled&t=${timestamp}`, { headers: this.headers })
      .pipe(
        map((response: any) => {
          return {
              data: response.data.map((counter: any) => ({
                title: counter.title,
                quantity: counter.quantity,
                detail: counter.detail,
              })),
          };
        })
    ));
  }

  async getPolicyFromApi() {
    const timestamp = new Date().getTime();
    return firstValueFrom(
      this.httpClient.get(`${this.apiUrl}/extra-datas?key=policy&t=${timestamp}`, { headers: this.headers })
      .pipe(
        map((response: any) => {
          return {
              data: {
                title: response.data.title,
                content: response.data.value,
              },
          };
        })
    ));
  }

  async getCommentsFromApi() {
    const timestamp = new Date().getTime();
    return firstValueFrom(
      this.httpClient.get(`${this.apiUrl}/testimonials?page=1&per_page=10&t=${timestamp}`, { headers: this.headers })
      .pipe(
        map((response: any) => {
          return {
              data: response.data.map((comment: any) => ({
                id: comment.id,
                name: comment.name + ' ' + comment.business_name,
                comment: comment.message,
                role: comment.position,
                rating: comment.rating,
              })),
          };
        })
    ));
  }

  async getPartnersFromApi() {
    const timestamp = new Date().getTime();
    return firstValueFrom(
      this.httpClient.get(`${this.apiUrl}/partners?paginate=disabled&t=${timestamp}`, { headers: this.headers })
      .pipe(
        map((response: any) => {
          return {
              data: response.data.map((partner: any) => ({
                id: partner.id,
                title: partner.title,
                image: partner.image?.url,
                url: partner.url,
              })),
          };
        })
    ));
  }
}
